import React, { lazy } from 'react';
import { clientRoutes } from 'router/routes/clientRoutes';
import { RoutePath } from 'router/routes/routePath';

const StructuresAddPage = lazy(() => import('pages/structures-add'));
const StructuresEditPage = lazy(() => import('pages/structures-edit'));
const StructureManagePage = lazy(() => import('pages/structure-manage'));
const UsersPage = lazy(() => import('pages/users'));
const OrganizationsPage = lazy(() => import('pages/organizations'));
const OrganizationDetailsPage = lazy(() => import('pages/organization-details'));
const SettingsPage = lazy(() => import('pages/settings'));
// const System3EPage = lazy(() => import('pages/system3e'));

export const adminRoutes = [
    ...clientRoutes.filter(({ noAdminAccess }) => !noAdminAccess),
    {
        path: RoutePath.StructuresAdd,
        component: <StructuresAddPage />,
    },
    {
        path: RoutePath.StructuresEdit,
        component: <StructuresEditPage />,
    },
    {
        path: RoutePath.StructuresManage,
        component: <StructureManagePage />,
    },
    {
        path: RoutePath.Users,
        component: <UsersPage />,
    },
    {
        path: RoutePath.Organizations,
        component: <OrganizationsPage />,
    },
    {
        path: RoutePath.OrganizationDetails,
        component: <OrganizationDetailsPage />,
    },
    // {
    //     path: RoutePath.System3E,
    //     component: <System3EPage />,
    // },
    {
        path: RoutePath.Settings,
        component: <SettingsPage />,
    },
];
